import { useQuery } from '@tanstack/react-query';

import { fetcher, throwApiError } from '@commenda/utils';

import { adminManagedAgentsKeys } from './keys';
import type { IAdminManagedAgentListResponse } from './types';

export function useAdminManagedAgents() {
  return useQuery({
    queryKey: adminManagedAgentsKeys.lists(),
    queryFn: async () => {
      const response = await fetcher('admin/managed-agents', { method: 'GET' });
      if (!response.ok)
        await throwApiError(response, 'Failed to load managed agents');
      return (await response.json()) as IAdminManagedAgentListResponse;
    },
    retry: 1,
  });
}
